module.exports = __webpack_public_path__ + "img/profile.ec316edd.svg";